import { makeStyles } from '@material-ui/core';
import _ from 'lodash';
import tw from 'twin.macro';

export default makeStyles(() => ({
  root: (styles) => ({
    border: 'inherit',
    '&': tw`items-center justify-center border border-gray-500 border-opacity-10`,
    '& .MuiFilledInput-root':
      styles && !_.isEmpty(styles) ? { ...styles, ...tw`bg-transparent` } : tw`w-95 bg-transparent`,
    '& .MuiFilledInput-root:hover': tw`bg-transparent`,
    '& .MuiFilledInput-input': { padding: '15px' },
    '& .MuiFilledInput-underline:before': tw`border-0`,
    '& .MuiFilledInput-underline:after': tw`border-0`,
    '& .MuiSelect-select:focus': tw`bg-transparent`,
    '& .MuiSvgIcon-root': tw`text-gray-500`,
    '& .MuiInputBase-root': tw`text-current font-body`,
  }),
  // checkbox: {
  //   '& .MuiCheckbox-root': tw`text-blue-600`,
  //   '&': tw`whitespace-nowrap`,
  // },
}));
